<template>
   <div id="mainview">
        <router-view></router-view>
    </div>
</template>

<script setup>

</script>